const form = document.querySelector("#filters form");
const inputArr = form.querySelectorAll("[data-filter]");
const typeFilter = form.querySelector("[data-filter-type]");
let destinationURL = undefined;

const updateURL = () => {
    let data =  new FormData(form);

    for (let entry of data) {
        if (entry[0] === "type") {
            destinationURL = `${entry[1]}?`;
        } else {
            destinationURL += `${entry[0]}=${entry[1]}`;
        }
    }
    window.location.href = destinationURL;
}


inputArr.forEach(input => {
    input.addEventListener("change", (e) => {
        e.preventDefault();
        
        updateURL();
    });
});

typeFilter.addEventListener("change", (e) => {
    updateURL();
});


// Sticky
const headerHeight = document.querySelector("#global-navigation").scrollHeight;
const stickyHeader = document.querySelector(".\\@top-header");
stickyHeader.style.top = headerHeight + 'px';



